import { singleton } from 'tsyringe';
import type { SignalTileDef } from './SignalTypes';

/**
 * Registry of each surface's landing-page signal tiles, keyed by surface id so
 * {@link SurfaceSignalGrid} can render any surface's default tiles, and the
 * Licenses dashboard (not an analytics surface) can pull its own set.
 * Populated at startup by the composition root — features contribute their
 * tiles via {@link register}, keeping this shared engine feature-blind.
 */
@singleton()
export class SurfaceSignalCatalog {
    private readonly signals = new Map<string, SignalTileDef[]>();

    register(surfaceId: string, defs: SignalTileDef[]): void {
        this.signals.set(surfaceId, defs);
    }

    /** The signal tiles for a surface id, or an empty list for an unknown surface. */
    signalsFor(surfaceId: string): SignalTileDef[] {
        return this.signals.get(surfaceId) ?? [];
    }
}
